import React, { h } from 'preact'

import style from './widget-frame.css'

interface Props {
    variant: 'compact' | 'large'
}

/**
 * Implements the overall frame for the Widget.
 *
 * There are 2 variants: `compact` and `large`
 *
 * @param param0
 * @returns
 */
export const WidgetFrame: React.FunctionalComponent<Props> = ({
    children,
    variant,
}) => {
    return (
        <div className={variant === 'compact' ? style.compact : style.large}>
            {children}
        </div>
    )
}
